/** 邮箱格式验证正则 */ export var EMAIL_REGEXP = /^[\w.%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
/** 表单验证规则集合 */ export var FORM_RULES = {
    email: [
        {
            required: true,
            match: EMAIL_REGEXP,
            get message () {
                return intl.get('FormRules_Email_Required');
            }
        }
    ],
    password: [
        {
            required: true,
            get message () {
                return intl.get('FormRules_Password_Required');
            }
        },
        {
            min: 6,
            max: 20,
            get message () {
                return intl.get('FormRules_Password_Length');
            }
        }
    ]
};
/** 用户服务条款链接 */ export var USER_TERMS_URL = 'https://privacy.wegic.ai/';
/** 隐私政策链接 */ export var USER_PRIVACY_POLICY_URL = 'https://privacy.wegic.ai/wegic-privacy-policy';
